// sentry-request-fix-wechat.js
(function () {
  // --- 工具函数：安全设置属性 ---
  function safeDefine(obj, key, value) {
    const desc = Object.getOwnPropertyDescriptor(obj, key);
    if (desc && desc.configurable === false) {
      // 微信 webview 可能出现这种情况：不可配置 → 不能 patch
      return false;
    }
    try {
      obj[key] = value;
      return true;
    } catch (e) {
      return false;
    }
  }

  // --- Patch fetch ---
  if (window.fetch) {
    const originalFetch = window.fetch;
    safeDefine(window, 'fetch', function (...args) {
      let url = args[0];
      let options = args[1] || {};

      if (typeof url === 'string' && options.headers) {
        // 处理 baggage 重写逻辑
        if (options.headers['baggage']) {
          options.headers['baggage'] = dedupeBaggage(options.headers['baggage']);
        }
      }

      return originalFetch.apply(this, args);
    });
  }

  // --- Patch XHR ---
  if (window.XMLHttpRequest) {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    safeDefine(XMLHttpRequest.prototype, 'open', function (method, url, ...rest) {
      this.__sentry_url__ = url;
      return originalOpen.call(this, method, url, ...rest);
    });

    safeDefine(XMLHttpRequest.prototype, 'send', function (body) {
      try {
        const url = this.__sentry_url__;

        if (url && this.setRequestHeader) {
          const originalSet = this.setRequestHeader;

          this.setRequestHeader = function (key, val) {
            if (key.toLowerCase() === 'baggage') {
              val = dedupeBaggage(val);
            }
            return originalSet.call(this, key, val);
          };
        }
      } catch (e) {
        // 微信可能限制 setRequestHeader 覆盖 → 静默失败
      }
      return originalSend.call(this, body);
    });
  }

  // --- 统一去重函数 ---
  function dedupeBaggage(headerVal) {
    if (!headerVal) return headerVal;
    const parts = headerVal.split(',');
    const map = new Map();

    for (const part of parts) {
      const [key, value] = part.split('=');
      map.set(key.trim(), value.trim());
    }
    return [...map.entries()].map(([k, v]) => `${k}=${v}`).join(',');
  }
})();
